import { render, staticRenderFns } from "./FutureStage.vue?vue&type=template&id=151bbd50&"
import script from "./FutureStage.vue?vue&type=script&lang=js&"
export * from "./FutureStage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports